import axios from 'axios';
import { genCustomConsole, getLocalStorage } from 'mazey';
import { staticDataBaseUrl, url2Keys } from '../conf/api';

// 验证返回的数据符合要求
export const verfAxiosRes = (res) => {
    let ret = false;
    if (res.status === 200) {
        const data1 = res.data;
        if (data1.code === 200) {
            const data2 = data1.data;
            if (Array.isArray(data2) && data2.length > 0) {
                ret = data2;
            }
        }
    }
    return ret;
};

// 停止刷新数据
export const stopRerefresh = () => {
    if (window.refreshTrainsIndex) {
        clearInterval(window.refreshTrainsIndex);
        window.refreshTrainsIndex = null;
    }
};

// 自定义日志打印
export const metroLog = genCustomConsole({ prefix: 'MetroLog:' });

// https://mazey.cn/server/agent
// 代理转发 todo 统一添加登录所需信息 修改 https://mazey.cn/server/agent 添加 headers
export const request = ({
    method = '',
    url = '',
    params = {},
    data = {},
    headers = {},
} = {}) => {
    // mock - begin
    let key;
    url2Keys.forEach((k, u) => {
        // metroLog.log('Got url2Keys: ', u, k, url);
        if (url && url.includes(u)) {
            metroLog.log('Got u: ', url, u, k);
            key = k;
        }
    });
    if (key) {
        Object.assign(params, { mockKey: key });
    }
    // mock - end
    // static data - begin
    if (key) {
        metroLog.log('staticDataBaseUrl', staticDataBaseUrl);
        const staticUrl = `${
            process.env.PUBLIC_URL || ''
        }/${staticDataBaseUrl}/${key}.json`;
        return axios.get(staticUrl);
    }
    // static data - end
    const AdminToken = getLocalStorage('AdminToken');
    const AdminExpiresIn = getLocalStorage('AdminExpiresIn');
    if (AdminToken && AdminExpiresIn) {
        Object.assign(headers, {
            'Admin-Token': AdminToken,
            'Admin-Expires-In': AdminExpiresIn,
            cookie: `Admin-Token=${AdminToken}; Admin-Expires-In=${AdminExpiresIn}`,
        });
    }
    return axios
        .post('https://mazey.cn/server/agent', {
            method,
            url,
            params,
            data,
            headers,
        })
        .then(function (response) {
            // console.log(response);
            metroLog.log(response);
            return response;
        })
        .catch(function (error) {
            // console.error(error);
            metroLog.error(error);
        });
};
